import { collectionStat } from '@/entities/collection';
import { useAppSelector } from '@/shared/hooks';
import { Box, ScrollArea, Text } from '@radix-ui/themes';

export function CollectedSkuStat() {
  const collectedSkus = useAppSelector(collectionStat);

  return (
    <>
      <Text as="p" className="font-medium my-1 px-3">
        SKUs collected in this session
      </Text>
      <ScrollArea className="mb-3 flex-grow flex flex-col px-1 max-h-[calc(100vh-560px)]">
        <ul className="flex flex-col flex-grow gap-2">
          {[...collectedSkus.skuList].reverse().map((sku) => (
            <li
              key={sku.id}
              className={'rounded-lg gap-2 flex items-center p-2'}
            >
              <img
                className="min-w-10 w-10 h-10 object-contain "
                src={sku.image}
              />
              <div className="flex-grow flex items-center justify-between">
                <Box>
                  <Text
                    size="2"
                    className="text-ellipsis overflow-hidden line-clamp-2"
                  >
                    {sku.display_name}
                  </Text>
                  <Text size="2" weight="bold">
                    {sku.sku}
                  </Text>
                </Box>
                <Text size="2" className="pl-2">
                  {collectedSkus.count[sku.id] || 0}
                </Text>
              </div>
            </li>
          ))}
        </ul>
      </ScrollArea>
    </>
  );
}
